import React, { useState } from "react";

import { Button, Tooltip, mergeClasses } from "@fluentui/react-components";
import { ShareScreenStart24Filled, ShareScreenStop24Filled } from "@fluentui/react-icons";

import { useShare } from "../room/useShare";
import { MediaDevices } from "../../utils/media-devices-utils";
import { useCssBreakpoints } from "react-use-css-breakpoints";

export default function ToolbarShareScreenButton({ styles, scene, hubChannel }) {
  const { canShareScreen, toggleShareScreen, sharingSource } = useShare(scene, hubChannel);
  const [visible, setVisible] = React.useState(false);
  const onClick = () => toggleShareScreen();
  const breakpoint = useCssBreakpoints();

  const isMobileBreakpoint = ["xs", "sm", "md"].includes(breakpoint);

  if (!canShareScreen) return <></>;

  const disableAndShowTooltip = sharingSource && sharingSource !== MediaDevices.SCREEN;
  const isSharingScreen = sharingSource && sharingSource === MediaDevices.SCREEN;

  return (
    <>
      {!isMobileBreakpoint && (
        <Tooltip
          visible={visible && disableAndShowTooltip}
          onVisibleChange={(_ev, data) => setVisible(data.visible)}
          content="Screen sharing is not available during camera sharing"
        >
          <Button
            disabled={disableAndShowTooltip}
            appearance="subtle"
            onClick={onClick}
            className={
              isSharingScreen
                ? styles.buttonActive
                : disableAndShowTooltip
                ? mergeClasses(styles.button, styles.buttonDisabled)
                : styles.button
            }
            icon={
              isSharingScreen ? (
                <ShareScreenStop24Filled style={{ width: "24px", height: "24px" }} />
              ) : (
                <ShareScreenStart24Filled style={{ width: "24px", height: "24px" }} />
              )
            }
          />
        </Tooltip>
      )}
    </>
  );
}
